export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_SUCCESS = "CONTACT_SUCCESS";
export const CONTACT_FAIL = "CONTACT_FAIL";
export const CONTACT_RESET = "CONTACT_RESET";
export const CONTACT_CLEAR_ERRORS = "CONTACT_CLEAR_ERRORS";
